<lib-contract-state-base
    title="Tu carta compromiso se está subiendo..."
    subtitle="Procesando..."
    [svg]="svg"
    [hasLoader]="true">
</lib-contract-state-base>
